import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wave-bye"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M6.40072 16.1019C5.85958 15.5608 5.85958 14.6834 6.40072 14.1423C6.94186 13.6011 7.81922 13.6011 8.36037 14.1423L6.27558 12.0575C5.73366 11.5156 5.73366 10.6369 6.27558 10.095C6.8175 9.55311 7.69612 9.55311 8.23804 10.095L6.87122 8.72821C6.3293 8.18629 6.3293 7.30767 6.87122 6.76575C7.41314 6.22384 8.29176 6.22384 8.83368 6.76575L10.2005 8.13257C9.65858 7.59065 9.65858 6.71203 10.2005 6.17011C10.7424 5.62819 11.621 5.62819 12.163 6.17011L17.6331 11.6403C17.634 11.6412 17.634 11.6388 17.6337 11.6376L16.965 9.14196C16.8412 8.67984 17.0176 8.18944 17.4074 7.91209C17.956 7.52182 18.7212 7.68647 19.0607 8.26783L21.287 12.0802C22.7054 14.5092 22.3076 17.5891 20.3187 19.578L19.4744 20.4223C17.0573 22.8395 13.1383 22.8395 10.7211 20.4223L6.40072 16.1019Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.36037 14.1423L10.8051 16.587M8.36037 14.1423L6.27558 12.0575C5.73366 11.5156 5.73366 10.6369 6.27558 10.095C6.8175 9.55311 7.69612 9.55311 8.23804 10.095M8.36037 14.1423C7.81922 13.6011 6.94186 13.6011 6.40072 14.1423C5.85958 14.6834 5.85958 15.5608 6.40072 16.1019L10.7211 20.4223C13.1383 22.8395 17.0573 22.8395 19.4744 20.4223L20.3187 19.578C22.3076 17.5891 22.7054 14.5092 21.287 12.0802L19.0607 8.26783C18.7212 7.68647 17.956 7.52182 17.4074 7.91209C17.0176 8.18944 16.8412 8.67984 16.965 9.14196L17.6325 11.6331C17.6331 11.6355 17.6314 11.6386 17.6296 11.6367L12.163 6.17011C11.621 5.62819 10.7424 5.62819 10.2005 6.17011C9.65858 6.71203 9.65858 7.59065 10.2005 8.13257M8.23804 10.095L12.7676 14.6245M8.23804 10.095L6.87122 8.72821C6.3293 8.18629 6.3293 7.30767 6.87122 6.76575C7.41314 6.22384 8.29176 6.22384 8.83368 6.76575L10.2005 8.13257M10.2005 8.13257L14.73 12.6621","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M5.76501 21.0637C4.65877 20.3013 3.699 19.3416 2.93652 18.2354M18.2354 2.93652C19.3416 3.699 20.3013 4.65877 21.0637 5.76501","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WaveBye = Vue.extend<IconProps>({
  name: 'WaveByeIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'wave-bye',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default WaveBye;
